<template>
  <div class="plan-offer-banner">
    <Banner outlined :color="color">
      <CountDownCard
        v-if="countDown"
        :days="countDown.days"
        :hours="countDown.hours"
        :minutes="countDown.minutes"
        :seconds="countDown.seconds"
      />
      <div class="content">
        <h5 class="content-title">
          {{ userName }}, {{ description }}.
        </h5>
        <p class="description">
          Com base na sua lista de contatos, o melhor plano para você é o <strong>{{ plan.title }}</strong>.<br>Economize
          <strong>{{ discountPercentage }}%</strong> assinando agora.
        </p>
      </div>
      <div class="action">
        <p class="text">
          De R$ {{ priceWithDiscount }} <strong>por R$ {{ price }}*</strong>
        </p>
        <v-btn
          color="#0FCF64"
          class="action-button ma-0"
          depressed
          large
          @click.prevent="onClick"
        >
          Economizar {{ discountPercentage }}%
        </v-btn>
        <p class="text-small">
          *{{ often }}
        </p>
      </div>
    </Banner>
  </div>
</template>

<script>
import Banner from '@/components/base/banner'
import CountDownCard from './CountDownCard'

export default {
  name: 'PlanOfferBanner',
  components: { Banner, CountDownCard },
  props: {
    offer: { type: Object, required: true },
    plan: { type: Object, required: true },
    userName: { type: String, required: true },
    onClick: { type: Function, required: false, default: () => {} }
  },
  data: () => ({
    countDown: { days: 0, hours: 0, minutes: 0, seconds: 0 }
  }),
  computed: {
    color() {
      if (this.offer.offer_id == 'first-broadcast') {
        return 'success'
      } else {
        return 'violet'
      }
    },
    description() {
      if (this.offer.offer_id == 'first-broadcast') {
        return 'parabéns pela primeira transmissão'
      } else {
        return 'aproveite a condição especial'
      }
    },
    price() {
      let price = (this.plan.value - this.plan.discount) / 100
      if (this.plan.discount_type === 'percentage') {
        price =
          (this.plan?.value - (this.plan?.value * this.plan?.discount) / 100) /
            100 || ''
      }

      return Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(price)
    },
    priceWithDiscount() {
      return Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(this.plan.value / 100)
    },
    discountPercentage() {
      if (this.plan.discount_type === 'percentage') return this.plan.discount
      if (this.plan.discount_type === 'amount')
        return parseInt((this.plan.discount * 100) / this.plan.value)
      return ''
    },
    often() {
      if (this.plan.discount) {
        if (this.plan.only_on_first_period) {
          if (this.plan.period === 'monthly') return 'no primeiro mês'
          if (this.plan.period === 'quarterly') return 'no primeiro trimestre'
          if (this.plan.period === 'yearly') return 'no primeiro ano'
        } else {
          if (this.plan.period === 'monthly') return 'a cada mês'
          if (this.plan.period === 'quarterly') return 'a cada trimestre'
          if (this.plan.period === 'yearly') return 'a cada ano'
        }
      }
      return ''
    }
  },
  mounted() {
    this.initExpirationCountDown()
  },
  methods: {
    initExpirationCountDown() {
      var expiration = new Date(this.offer.expires_at).getTime()
      var self = this
      var x = setInterval(function() {
        var now = new Date().getTime()
        var distance = expiration - now
        var days = Math.floor(distance / (1000 * 60 * 60 * 24))
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        )
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        var seconds = Math.floor((distance % (1000 * 60)) / 1000)
        hours = hours < 10 ? '0' + hours : hours
        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds
        self.countDown = { days, hours, minutes, seconds }
        if (distance < 0) {
          self.countDown = { days: 0, hours: 0, minutes: 0, seconds: 0 }
          clearInterval(x)
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.plan-offer-banner {
  .banner {
    align-items: center;
    justify-content: last flex-end;
    display: grid;
    display: inline-grid;
    grid-column-gap: 24px;
    grid-template-rows: 1fr 2fr 1fr;
    align-items: center;

    column-gap: $scale800;

    @include media-query($small-breakpoint) {
      grid-template-columns: 1fr 2fr 1fr;
      grid-template-rows: 1fr;
    }

    .content {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
      color: $neutral500;

      .content-title {
        @include ParagraphMedium;
        font-family: $monserratFontFamily;
        font-weight: 700;
      }

      .description {
        @include LabelXSmall;
        font-family: $monserratFontFamily;
      }
    }

    .action {
      display: flex;
      gap: 4px;
      flex-direction: column;
      width: fit-content;
      color: $neutral500;
      justify-self: end;

      .text {
        @include LabelXSmall;
        font-family: $monserratFontFamily;
      }

      .text-small {
        @include LabelXSmall;
        font-family: $monserratFontFamily;
        font-size: 10px;
        color: $neutral400;
      }

      .action-button {
        @include LabelSmall;
        font-family: $monserratFontFamily;
        font-weight: 700;
        color: $neutral500;

        border-radius: 8px;
      }
    }
  }
}
</style>
